import { Icon, type IconTypes } from '@procurify/ui'

import {
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from './CatalogItemTagVariants'
import { CatalogItemTagIconStyled } from './styles/CatalogItemTagIconStyled'
import { CatalogItemTagLabelStyled } from './styles/CatalogItemTagLabelStyled'
import { CatalogItemTagLayoutStyled } from './styles/CatalogItemTagLayoutStyled'

export interface ICatalogItemTagProps {
  icon: IconTypes
  text: string
  variant?: CatalogItemTagVariant
}

export const CatalogItemTag = ({
  icon,
  text,
  variant = CatalogItemTagVariants.DEFAULT,
}: ICatalogItemTagProps) => (
  <CatalogItemTagLayoutStyled $variant={variant}>
    <CatalogItemTagIconStyled $size={16}>
      <Icon icon={icon} size={16} aria-hidden />
    </CatalogItemTagIconStyled>
    <CatalogItemTagLabelStyled>{text}</CatalogItemTagLabelStyled>
  </CatalogItemTagLayoutStyled>
)
